import styled, { RuleSet, css } from 'styled-components';
import { CARD_STATUS } from '.';

export const Card = styled.div<{ $isPrimaryBackground?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-basis: min-content;
  gap: 32px;
  border-radius: 8px;
  background-color: ${({ $isPrimaryBackground, theme }) =>
    $isPrimaryBackground ? theme.primary_200 : theme.neutral_200};
  padding: 16px 32px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  min-width: 64px;
  min-height: 64px;
  border-radius: 64px;
  background-color: ${({ theme }) => theme.neutral_100};

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Description = styled.div`
  display: flex;
  gap: 4px;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const valueWrapperColor: { [key in CARD_STATUS]: RuleSet<object> } = {
  default: css`
    ${({ theme }) => theme.neutral_500}
  `,
  positive: css`
    ${({ theme }) => theme.success_300}
  `,
  negative: css`
    ${({ theme }) => theme.danger_500}
  `,
};

export const ValueWrapper = styled.div<{ $status: CARD_STATUS }>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ $status, theme }) => valueWrapperColor[$status]};
`;
